import PublicMachineLocalisationEtStatut from './publicMachineLocalisationEtStatut';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import PublicMachineChiffreClePart from './publicMachineChiffreClePart';
import PublicMachineModeEtConsigne from './publicMachineModeEtConsigne';
import PublicMachineDetailsHeader from './publicMachineDetailsHeader';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import PublicMachineMachineImage from './publicMachineMachineImage';
import PublicMachineEquipment from './publicMachineEquipment';
import PublicMachineContent from './publicMachineContent';
import { Box, Grid, CircularProgress } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import PublicMachineRisk from './publicMachineRisk';
import { useParams } from 'react-router-dom';
import NoRecord from '../../NoRecord';
import axios from 'axios';

const PublicMachineDetails = () => {

  const { token } = useParams();

  const [errMsg, setErrMsg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [machine, setMachine] = useState({});

  const fetchMachineDetails = useCallback(async ({ silent = false } = {}) => {
    try {
      if (!silent) {
        setLoading(true);
      }
      const { status, data } = await axios.get(`machine/findOneForQrCodeReview/${token}`, {
        skipSessionTrace: true,
      });
      if (status === 200 || status === 201) {
        setMachine(data);
      }
    } catch (error) {
      if (!silent) {
        setErrMsg(error.message);
      }
      console.error('Error Fetching Machine Details:', error);
      CustomErrorLogger(error, "Fetch Machine Details Error in MachineDetails");
    }
    finally {
      if (!silent) {
        setLoading(false);
      }
    }
  }, [token]);

  useEffect(() => {
    fetchMachineDetails();
    const renewId = setInterval(() => fetchMachineDetails({ silent: true }), 3 * 60 * 60 * 1000);
    return () => clearInterval(renewId);
  }, [fetchMachineDetails]);

  return (
    <Box>
      {loading ?
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <CircularProgress
            sx={{ '& .MuiCircularProgress-circle': { stroke: '#EA5E00' } }}
          />
        </Box>
        :
        errMsg ?
          <NoRecord description="Machine non trouvée" />
          :
          <Box>
            <PublicMachineDetailsHeader machine={machine} />
            <Grid container spacing={3} sx={{ padding: '20px 20px 0px 20px' }}>
              <Grid item xs={12} md={4} padding={3}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
                  <PublicMachineMachineImage machineImage={machine?.machine_image || []} />
                  <PublicMachineChiffreClePart contract_machine={machine?.contract_machine || []} />
                  <PublicMachineEquipment equipment_machine={machine?.equipment_machine || []} />
                  <PublicMachineRisk risk_machine={machine?.risk_machine || []} />
                </Box>
              </Grid>
              <Grid item xs={12} md={8} padding={3}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
                  <PublicMachineLocalisationEtStatut machine={machine} />
                  <PublicMachineModeEtConsigne machine={machine} />
                  <PublicMachineContent items={machine?.machine_content || []} />
                </Box>
              </Grid>
            </Grid>
            <SuccessfullModifyDialog />
          </Box>
      }
    </Box>
  );
}

export default PublicMachineDetails;